import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useStore, useStorePersist } from "store/context";

import { UnidadService } from 'services/UnidadService';
import useRequest from 'hooks/useRequest';

import GradientButton from 'components/atoms/GradientButton';
import MainLayout from 'components/Layouts/MainLayout';
import InputText from 'components/atoms/InputText';
import Modal from 'components/atoms/Modal';

import signopregunta from 'assets/images/signo-pregunta.png';
import unidadfactura from 'assets/images/unidadfactura.png';
import unidadalternativa from 'assets/images/unidadalternativa.png';

import './styles.scss';

const VincularView = (props) => {
    const history = useHistory();

    const {
        submitted, success, message, errors,
        beforeSubmit, afterSubmit, showError,
        dealWithError
    } = useRequest();

    const [{}, dispatch] = useStore();

    const [{
        unidades,  // El listado de las unidades
    }, dispatchPersist] = useStorePersist();

    const [nroUnidad, setnroUnidad] = useState("");
    const [partido, setpartido] = useState("");
    const [alias, setAlias] = useState("");

    const [showUF, setShowUF] = useState(false);
    const [showUA, setShowUA] = useState(false);

    const handleShowUA = () => {
        setShowUA(true);
    }
    const handleCloseUA = () => {
        setShowUA(false);
    }

    const handleShowUF = () => {
        setShowUF(true);
    }

    const handleCloseUF = () => {
        setShowUF(false);
    }

    const bodyUF = <> 
    <span className="body-uf">
        <p>Se encuentra en la parte superior derecha de tu factura.</p>
    </span>
    <span className="body-uf">
        <img src={unidadfactura}></img>
    </span></>;
    
    const bodyUA = <>
    <span className="body-ua">
        <p>Se encuentra en la parte superior izquierda de tu factura.</p>
    </span>
    <span className="body-ua">
        <img src={unidadalternativa}></img>
    </span></>;

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        const data = {
            nroUnidad: parseInt(nroUnidad),
            partido: partido,
            alias: alias
        }

        UnidadService.vincular(data)
            .then(data => {
                afterSubmit();
                dispatchPersist({
                    type: 'resetUnidades',
                    payload: {},
                });
                dispatchPersist({
                    type: 'resetUnidadesPersist',
                    payload: {},
                });
                getUnidades();
                history.push('/unidades_adheridas');
            }).catch((error) => {
                dealWithError(error, '');
            });
    }

    const getUnidades = () => {
        beforeSubmit();
        UnidadService.unidades({})
            .then((unidades) => {
                
                dispatchPersist({
                    type: 'setUnidades',
                    payload: unidades
                });
                
                afterSubmit();
                if (unidades.length === 0) {
                    history.push('/unidades_adheridas');
                    return;
                }
            }).catch((error) => {
                afterSubmit();
            });
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    return (
        <>
        <MainLayout>
            <div className="vincular-container">
                <div className="vincular-content">
                    <form className="vincular-form" onSubmit={handleSubmit}>
                        <h1 className="vincular-title">Vincular Unidad de Facturación</h1>
                        <div className="vincular-input-group">
                            <div className="vincular-input-container">
                                    <InputText type="number" onInput={maxLengthCheck} id="nroUnidad" label={<span onClick={handleShowUF}><span>UNIDAD DE FACTURACIÓN</span><img className="signopregunta" src={signopregunta}></img></span>} maxLength="10" placeholder="Hasta 10 dígitos"
                                    handleChange={(event) => { setnroUnidad(event.target.value) }} error={errors.nroUnidad} />
                            </div>
                        </div>
                        <div className="vincular-input-group">
                            <div className="vincular-input-container">
                                    <InputText id="partido" label={<span onClick={handleShowUA}><span>UNIDAD ALTERNATIVA (PARTIDO-PARTIDA)</span><img className="signopregunta" src={signopregunta}></img></span>} maxLength="20" placeholder="Hasta 20 dígitos alfanuméricos (mayúsculas, sin guiones)"
                                    handleChange={(event) => { setpartido(event.target.value) }}
                                    type="text" error={errors.partido} />
                            </div>
                        </div>
                        <div className="vincular-input-group">
                            <div className="vincular-input-container">
                                <InputText id="alias" label="ALIAS" placeholder=""
                                    handleChange={(event) => { setAlias(event.target.value) }}
                                    type="text" error={errors.alias} />
                            </div>
                        </div>
                        {(success === false && message) &&
                            <p className="error-messages">{message}</p>
                        }
                        <div className="vincular-button">
                            <GradientButton legend={'VINCULAR'} disabled={submitted}
                                handleClick={handleSubmit} type={'submit'} />
                        </div>
                    </form>
                </div>
            </div>
        </MainLayout>
        <Modal className="modal-unidad-facturacion" title="UNIDAD DE FACTURACION" body={bodyUF} handleClose={handleCloseUF} show={showUF}></Modal>
        <Modal className="modal-unidad-alternativa" title="PARTIDO/PARTIDA" body={bodyUA} handleClose={handleCloseUA} show={showUA}></Modal>
        </>
    );
}

export default withTranslation()(VincularView);